module.exports = __webpack_public_path__ + "static/img/Germany.4711628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/Germany.jpg
// module id = TI7j
// module chunks = 1